import API from '@/services/api'

export default {
  getFacilities() {
    return API.get('/facilities')
  },
  getFacility(id) {
    return API.get('/facilities/' + id)
  },
  getPrograms(id) {
    return API.get('/facilities/' + id + '/programs')
  },
  getLatestForecast(id) {
    return API.get('/facilities/' + id + '/forecast/latest')
  },
  getForecastByDate(id, ts) {
    return API.get('/facilities/' + id + '/forecast/date/' + ts)
  },
  getLatestPerformance(id) {
    return API.get('/facilities/' + id + '/performance/latest')
  },
  getPerformanceByDate(id, ts) {
    console.log('/facilities/' + id + '/performance/date/' + ts)
    return API.get('/facilities/' + id + '/performance/date/' + ts)
  },
  getPerformanceSummary(id, start, end) {
    return API.get(
      '/facilities/' + id + '/performance/summary/' + start + '/' + end
    )
  },
  getGeneratorsSummary(id, start, end) {
    return API.get(
      '/facilities/' + id + '/generators/summary/' + start + '/' + end
    )
  }
}
